import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const testimonials = [{
  name: 'Marco D.',
  role: 'Liceo Classico',
  city: 'Bologna',
  tag: '+1 punto alla Maturità',
  text: 'Insegno da 18 anni e questo è il primo strumento che mi fa davvero risparmiare tempo senza sacrificare la qualità. I miei studenti di quinta liceo hanno affrontato la Maturità con una sicurezza che non avevo mai visto prima.'
}, {
  name: 'Lucia M.',
  role: 'Scuola Media',
  city: 'Napoli',
  tag: 'Serate libere ritrovate',
  text: 'Le schede BES/DSA sono oro puro. Non devo più semplificare tutto a mano la sera prima. La mia classe di terza media ora segue Dante con un entusiasmo mai visto.'
}, {
  name: 'Paolo C.',
  role: 'Istituto Tecnico',
  city: 'Firenze',
  tag: '+4 ore libere a settimana',
  text: 'Le slide LIM su Leopardi e Pirandello sono straordinarie. La classe è coinvolta come mai prima. Recupero almeno 4 ore di preparazione a settimana, quasi mezza giornata libera.'
}, {
  name: 'Giulia R.',
  role: 'Scuola Media',
  city: 'Torino',
  tag: 'Inclusione DSA e BES',
  text: "Ero scettica all'inizio: pensavo fosse il solito PDF generico. Invece ho trovato un percorso completo, con UDA che funzionano davvero. Ho usato i materiali BES con due alunni DSA e hanno passato la verifica."
}, {
  name: 'Alessandro P.',
  role: 'Liceo Scientifico',
  city: 'Roma',
  tag: 'Maturità più chiara',
  text: 'Ho finalmente recuperato le mie serate. Le slide sul Novecento hanno illuminato i miei ragazzi della quinta. Indispensabile per chi insegna alle superiori.'
}, {
  name: 'Sara B.',
  role: 'Docente Precaria',
  city: 'Bari',
  tag: 'Pronta al volo',
  text: 'Cambio scuola ogni anno e dover preparare tutto da zero mi distruggeva. Con Lettere Pronte arrivo in classe il primo giorno con il programma già impostato. Vale dieci volte il prezzo.'
}];
export function Testimonials() {
  return <section className="py-10 sm:py-14 px-4" data-id="element-258">
      <div className="max-w-6xl mx-auto" data-id="element-259">
        <p className="text-center text-xs font-black tracking-widest text-brand-orange uppercase mb-3" data-id="element-260">
          Recensioni verificate
        </p>
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-black text-center mb-3 text-brand-cream" data-id="element-261">
          Cosa dicono i docenti che lo usano ogni giorno
        </motion.h2>
        <p className="text-center text-gray-400 text-sm mb-8" data-id="element-262">
          Oltre +800 docenti italiani hanno già scelto Lettere Pronte. Ecco cosa
          raccontano.
        </p>

        <div className="grid grid-cols-1 gap-4" data-id="element-263">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-brand-card border border-white/5 p-6 rounded-2xl flex flex-col" data-id="element-264">
              <div className="flex items-center justify-between mb-3" data-id="element-265">
                <div className="flex text-brand-gold" data-id="element-266">
                  {[...Array(5)].map((_, idx) => <StarIcon key={idx} className="w-4 h-4 fill-current" data-id="element-267" />)}
                </div>
                <div className="flex items-center gap-1 text-[10px] font-bold text-green-400 uppercase" data-id="element-268">
                  <ShieldCheckIcon className="w-3 h-3" data-id="element-269" />
                  Verificato
                </div>
              </div>
              <p className="text-gray-300 font-medium italic mb-5 text-sm sm:text-base leading-relaxed" data-id="element-270">
                "{t.text}"
              </p>
              <div className="border-t border-white/10 pt-3 mt-auto flex items-center justify-between gap-3" data-id="element-271">
                <div data-id="element-272">
                  <div className="font-bold text-brand-cream text-sm" data-id="element-273">
                    {t.name}
                  </div>
                  <div className="text-xs text-gray-400" data-id="element-274">
                    {t.role}, {t.city}
                  </div>
                </div>
                <div className="bg-brand-orange/10 border border-brand-orange/30 text-brand-orange text-[10px] font-black px-2.5 py-1 rounded-full uppercase tracking-wide text-right" data-id="element-275">
                  {t.tag}
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-8 text-center" data-id="element-276">
          <div className="inline-flex items-center gap-3 bg-brand-card border border-brand-gold/30 rounded-full px-5 py-2 mb-4" data-id="element-277">
            <span className="font-bold text-brand-cream text-sm" data-id="element-278">
              +800 docenti hanno già scelto il Kit
            </span>
            <span className="text-gray-600" data-id="element-279">•</span>
            <span className="text-brand-gold font-bold text-sm" data-id="element-280">4.9/5 ⭐</span>
          </div>
          <CTAButton href="https://italia.kitonline.shop/cart/44566018293895:1" className="max-w-sm mx-auto" data-id="element-281">
            VOGLIO IL KIT
          </CTAButton>
        </div>
      </div>
    </section>;
}